import { useEffect, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import ParticleBackground from "../components/common/ParticleBackground";

export default function Success() {

  const [orderId, setOrderId] = useState(null);
  const location = useLocation();

  useEffect(() => {
    // 🧹 limpiar carrito
    localStorage.removeItem("cart");

    // 🔍 obtener datos de la URL
    const params = new URLSearchParams(location.search);

    const externalRef = params.get("external_reference");

    if (externalRef) {
      setOrderId(externalRef);
    }

  }, [location.search]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        textAlign: "center",
        background: `
          radial-gradient(circle at 50% 0%, rgba(255,110,0,0.15), transparent 40%),
          linear-gradient(180deg, #141414 0%, #2a1208 100%)
        `
      }}
    >
      <ParticleBackground />

      <Typography
        variant="h3"
        sx={{
          color: "#fff",
          mb: 2,
          textShadow: "0 0 20px rgba(0,255,100,0.7)"
        }}
      >
        ✅ Pago aprobado
      </Typography>

      <Typography sx={{ color: "#aaa", mb: 2 }}>
        Tu compra fue realizada con éxito
      </Typography>

      {/* 🔥 DETALLE PRO */}
      {orderId && (
        <Typography sx={{ color: "#ffae00", mb: 3 }}>
          ID de orden: {orderId}
        </Typography>
      )}

      <Button
        component={Link}
        to="/shop"
        variant="contained"
        sx={{
          background: "linear-gradient(90deg, #ff6e00, #ffae00)"
        }}
      >
        Volver a la tienda
      </Button>
    </Box>
  );
}